export default __webpack_public_path__ + "static/media/deeplearning_ai_logo.4e39076f.png";